import {
  legacyContractAttrs,
  legacyContractDataAttrs,
  legacyCssClasses,
  type LegacyContractName,
} from '@/msgdeskRuntime/legacyBridge/SelectorContracts'

// Shared helpers for the editor section components.
// Component-specific behaviour now lives inside each component (NameKey owns its
// smart-name request helpers; Recipients owns its commit helper). Only the truly
// shared primitives stay here.
export const css = legacyCssClasses

export function contract(contract: LegacyContractName, needsRealId = true) {
  return needsRealId ? legacyContractAttrs(contract) : legacyContractDataAttrs(contract)
}
